/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerfollowqrdownload3Inputs */

const en_organizerfollowqrdownload3 = /** @type {(inputs: Organizerfollowqrdownload3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download QR as image`)
};

const de_organizerfollowqrdownload3 = /** @type {(inputs: Organizerfollowqrdownload3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR als Bild herunterladen`)
};

/**
* | output |
* | --- |
* | "Download QR as image" |
*
* @param {Organizerfollowqrdownload3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowqrdownload3 = /** @type {((inputs?: Organizerfollowqrdownload3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowqrdownload3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowqrdownload3(inputs)
	return de_organizerfollowqrdownload3(inputs)
});
export { organizerfollowqrdownload3 as "organizerFollowQrDownload" }